import Vue from 'vue'
import api from '@/api/client'
import { getCurrentLocale } from '@/i18n/locale'

const state = Vue.observable({
  list: [],
  loaded: false,
  loading: false,
  detailCache: {},
  lang: getCurrentLocale()
})

export function getArticlesLang() {
  return state.lang || 'zh'
}

export function setArticlesLang(lang) {
  const next = lang === 'en' ? 'en' : 'zh'
  if (state.lang === next) return
  state.lang = next
  state.loaded = false
  state.detailCache = {}
}

function detailCacheKey(id, lang = state.lang) {
  return `${lang || 'zh'}:${Number(id)}`
}

export async function loadArticles(force = false) {
  if (state.loading) return state.list
  if (state.loaded && !force) return state.list

  state.loading = true
  try {
    const res = await api.getArticles({ lang: getArticlesLang() })
    state.list = res.data.list || []
    state.loaded = true
  } catch {
    state.list = []
    state.loaded = true
  } finally {
    state.loading = false
  }
  return state.list
}

export function getArticles() {
  return state.list
}

export async function fetchArticleById(id) {
  const numId = Number(id)
  const key = detailCacheKey(numId)
  if (state.detailCache[key]) {
    return state.detailCache[key]
  }
  try {
    const res = await api.getArticle(numId, { lang: getArticlesLang() })
    state.detailCache[key] = res.data
    return res.data
  } catch {
    return null
  }
}

export function getArticleByIdSync(id) {
  const numId = Number(id)
  const key = detailCacheKey(numId)
  if (state.detailCache[key]) return state.detailCache[key]
  return getArticles().find(a => a.id === numId) || null
}

export function invalidateArticles() {
  state.loaded = false
  state.detailCache = {}
}

export const articlesStore = state

export default {
  get list() { return state.list },
  get loaded() { return state.loaded },
  get loading() { return state.loading },
  get lang() { return state.lang },
  loadArticles,
  fetchArticleById,
  getArticleByIdSync,
  invalidateArticles,
  setArticlesLang,
  getArticlesLang
}
